export default __webpack_public_path__ + "static/media/campaignmonitor.19b78afd.svg";